module.exports = "/images/assistance.jpg?b45845acee35686ef0cc3358225382c8";